import { useMutation } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

export function useVerifyOtp() {
  return useMutation({
    mutationFn: ({ token, code }: { token: string; code: string }) =>
      publicProposalApi.verifyOtp(token, code),
  });
}
